import { render } from "./AdditionalMenuMeetingTheme.vue?vue&type=template&id=72dfeade&scoped=true"
import script from "./AdditionalMenuMeetingTheme.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./AdditionalMenuMeetingTheme.vue?vue&type=script&charset=utf-8&lang=js"

import "./AdditionalMenuMeetingTheme.vue?vue&type=style&index=0&id=72dfeade&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dfeade"]])

export default __exports__